// extracted by mini-css-extract-plugin
module.exports = {"help_desk_header":"HelpDeskHeader_help_desk_header__q_SIY","help_desk_header_title":"HelpDeskHeader_help_desk_header_title__urqcr"};